module.exports = __webpack_public_path__ + "static/img/Haumole-Olakau’atu.ca17435.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Haumole-Olakau’atu.jpg
// module id = Rnqp
// module chunks = 0